<template>
  <v-breadcrumbs class="pa-0" :items="projectBreadcrumb"></v-breadcrumbs>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'project-breadcrumb',
  components: {},
  data: () => ({
  }),
  computed: {
    ...mapGetters('routes', [
      'projectBreadcrumb',
    ]),
  },
};
</script>
